export type ReminderType =
  | "service_reminder"
  | "vehicle_renewal"
  | "contact_renewal";

export const reminderTypeLabels: Record<ReminderType, string> = {
  service_reminder: "Service",
  vehicle_renewal: "Vehicle renewals",
  contact_renewal: "Contact renewals",
};
